import { render, staticRenderFns } from "./SectionGovCollaboration.vue?vue&type=template&id=1f1e0fff&scoped=true"
import script from "./SectionGovCollaboration.vue?vue&type=script&lang=ts"
export * from "./SectionGovCollaboration.vue?vue&type=script&lang=ts"
import style0 from "./SectionGovCollaboration.vue?vue&type=style&index=0&id=1f1e0fff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e0fff",
  null
  
)

export default component.exports